export default {
  createItem: {
    server: '/projects/{projectId}/structures/{structureId}/bims',
    method: 'post',
  },
  getList: {
    server: '/projects/{projectId}/structures/{structureId}/bims',
    method: 'get',
  },
  updateItem: {
    server: '/projects/{projectId}/structures/{structureId}/bims/{bimId}',
    method: 'put',
  },
  deleteItem: {
    server: '/projects/{projectId}/structures/{structureId}/bims/{bimId}',
    method: 'delete',
  },

  // 获取bimface模型viewToken
  getViewToken: {
    server: '/projects/{projectId}/structures/{structureId}/bimface/view-token',
    method: 'get',
  },
  // 获取bimface文件直传凭证
  getBimUploadPolicy: {
    server: '/projects/{projectId}/structures/{structureId}/bimface/upload-policy',
    method: 'post',
  },
  // bimface文件上传成功后更新结构物BIM文件ID
  createStructureBim: {
    server: '/projects/{projectId}/structures/{structureId}/bimface/file',
    method: 'post',
  },
  // 获取bimface源文件
  getSourceFile: {
    server: '/projects/{projectId}/structures/{structureId}/bimface/file',
    method: 'get',
  },
  deleteSourceFile: {
    server: '/projects/{projectId}/structures/{structureId}/bimface/file',
    method: 'delete',
  },
  translateSourceFile: {
    server: '/projects/{projectId}/structures/{structureId}/bimface/translate',
    method: 'post',
  },
  updateTranslateStatus: {
    server: '/projects/{projectId}/structures/{structureId}/bimface/update-translate-status',
    method: 'post',
  },
};
